import { Message } from 'element-ui';
import { HS_upload } from "./huoshanUpload";
import { customAlphabet } from 'nanoid';
const nanoid = customAlphabet('abcdefghijklmnopqrstuvwxyz1234567890', 32);
let _this;

tinymce.PluginManager.add('uploadVideo', function (editor, url) {
    editor.ui.registry.addIcon(
        "video-icon",
        `<svg width="25" height="25" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="design-iconfont">
  <mask id="pzw8yoccq__rpqjulmvna" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
    <path fill="#D9D9D9" d="M0 0H24V24H0z"/>
  </mask>
  <g fill="none" mask="url(#pzw8yoccq__rpqjulmvna)" stroke="#333" stroke-width="1.5">
    <path d="M3.75 3.75H20.25V20.25H3.75V3.75Z" stroke-linejoin="round"/>
    <path d="M15.375 11.3505C15.875 11.6392 15.875 12.3608 15.375 12.6495L10.875 15.2476C10.375 15.5363 9.75 15.1754 9.75 14.5981L9.75 9.40192C9.75 8.82457 10.375 8.46373 10.875 8.7524L15.375 11.3505Z"/>
  </g>
</svg>
`
    );

    // 注册一个工具栏按钮名称
    editor.ui.registry.addButton('uploadVideo', {
        icon: `video-icon`,
        tooltip: '插入视频',
        onAction: function () {
            var input = document.createElement("input");
            input.setAttribute("type", "file");
            input.setAttribute("accept", "video/*");
            input.click();
            input.onchange = function (e) {
                let file = this.files[0];
                const isVIDEO = file.type.indexOf("video/") >= 0;
                if (!isVIDEO) {
                    Message.error("请上传符合规格的视频格式！");
                } else {
                    file.is_must = 1;

                    const nanoidGet = nanoid(32);
                    editor.insertContent(`<div class="get-cover" contenteditable="false" data-nanoid="${nanoidGet}" data-originId="" id=""><div class="videoProcessContain"><div class="videoProcess"></div></div><div class="tip">视频上传中...</div></div>`);

                    cosUploadFile(file, (fileUrl, vid, originThumb, nanoidFinish) => {
                        Message({
                            showClose: true,
                            message: '上传成功，视频转码中，可正常提交',
                            type: 'warning',
                            duration: 5000,
                        });

                        let videoItems = document.getElementsByClassName("get-cover");
                        videoItems = Array.from(videoItems);
                        videoItems.forEach((item1) => {
                            if (item1.getAttribute("data-nanoid") == nanoidFinish) {
                                item1.setAttribute("data-originId", vid);
                                item1.setAttribute("id", fileUrl);
                                item1.innerHTML = `<img src="${require('../assets/videoIcon.png')}" class="videoIcon"><img src="${originThumb}" class="videoCover"><div class="tip">视频转码中，此处不支持视频播放</div>`;
                            }
                        });
                    }, nanoidGet);
                }
            };
        }
    });

    return {
        getMetadata: function () {
            return {
                //插件名和链接会显示在“帮助”→“插件”→“已安装的插件”中
                name: "",//插件名称
                url: "", //作者网址
            };
        }
    };
});

function cosUploadFile(file, callback, nanoid) {
    HS_upload(file, (data) => {
        _this.progressPercentArray[nanoid] = 100;
        callback(data.videoUri, data.Vid, data.PosterUri, nanoid);
    }, (error) => {
        console.log("error:" + error);
    }, (processPercent) => {
        console.log("processPercent:" + processPercent);
        if (!_this.progressPercentArray[nanoid]) {
            _this.$set(_this.progressPercentArray, nanoid, 0);
        }
        _this.progressPercentArray[nanoid] = Math.floor(processPercent);
    })
};

export default function map_callback(self) {
    _this = self;
};